import React, { useEffect, useState } from 'react'
import useTypedSelector from 'hooks/useTypedSelector'
import { setMask } from 'utils'
import { useDispatch, useSelector } from 'react-redux'
import { StoreState } from '../../store'
import { getPayment } from '../../store/payments/paymentActions'
import { putAlertsUser } from 'store/alertsUser/alertsUserActions'

export const UserAlerts = ({ id }: { id: string }) => {
  const { churches } = useTypedSelector(({ sessionState }) => ({
    churches: sessionState.user?.churches || [],
  }))

  const [checked, setChecked] = useState(false)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getPayment())
  }, [dispatch])

  const { payment, email } = useSelector(
    ({ paymentState, sessionState }: StoreState) => ({
      payment: paymentState.payment,
      email: sessionState.user?.email,
    })
  )

  const handleAccept = () => {
    const form = {
      status: 'accepted',
      email,
    }
    window.location.reload()
    dispatch(putAlertsUser(id, form))
  }

  const monthly = payment.filter((item) => item.paymentType === 'monthly')

  const implantation = payment.filter(
    (item) => item.paymentType === 'implantation'
  )

  return (
    <>
      <div>
        <div className="flex flex-col bg-gray-600 justify-center items-center ">
          <div className="md:w-1/2 sm:w-full rounded-lg shadow-xl   bg-white my-3 mb-16 mt-16">
            <div className="flex  justify-between border-b border-gray-100 px-5 py-4">
              <div>
                <span className=" font-bold text-gray-700 text-lg ">
                  CONTRATO DE PRESTAÇÃO DE SERVIÇOS DE SOFTWARE
                </span>
              </div>
              <div>
                <button>
                  <i className="fa fa-times-circle text-red-500 hover:text-red-600 transition duration-150"></i>
                </button>
              </div>
            </div>

            <div className="px-10 py-5 overflow-auto text-gray-600">
              <h4 className="text-lg mb-4 font i">
                Pelo presente instrumento particular, de um lado, a Igreja nas
                Nuvens (pseudônimo)*, tendo como razão social INTERFACE SISTEMAS
                COMERCIAIS DE TERESÓPOLIS LTDA, com sede na AV FELICIANO SOBRE
                Nº 1083 SALA 909, VÁZERA TERESÓPOLIS/RJ, inscrita no CNPJ sob o
                nº 11.308.874/0001-27, doravante denominada CONTRATADA, e de
                outro lado, {churches[0].name}, inscrito no CNPJ sob o nº
                {setMask('cnpj', churches[0].cnpj)}, residente em{' '}
                {churches[0]?.address?.street} {churches[0]?.address?.number}{' '}
                {churches[0]?.address?.complement}{' '}
                {churches[0]?.address?.neighborhood}{' '}
                {churches[0]?.address?.city} {churches[0]?.address?.state} ,
                doravante denominado CONTRATANTE, têm entre si ajustado o
                seguinte contrato de prestação de serviços:
              </h4>
              <ul className="mb-4">
                <p className="">1. Objeto do contrato:</p>
                <li className="ml-4">
                  1.1 A CONTRATADA se compromete a prestar ao CONTRATANTE
                  serviços de um software de controle financeiro, totalmente na
                  web, com funcionalidades que permitam ao CONTRATANTE gerência
                  suas finanças e visualizar relatórios de resultados;
                </li>

                <li className="ml-4">
                  1.2 O software será disponibilizado por meio de acesso via
                  internet, através de login e senha fornecidos pela CONTRATADA
                  ao CONTRATANTE.
                </li>
              </ul>
              <ul className="mb-4">
                <p className="">2. Prazo:</p>
                <li className="ml-4">
                  2.1. O prazo para a prestação dos serviços se estenderá
                  enquanto o CONTRATANTE manter o pagamento do plano
                  selecionado.
                </li>
              </ul>
              <ul className="mb-4">
                <p className="">3. Remuneração:</p>

                <li className="ml-4">
                  3.1. Em contraprestação aos serviços prestados pela
                  CONTRATADA, o CONTRATANTE pagará na aquisição do serviço{' '}
                  {Number(implantation[0]?.price).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })}{' '}
                  à CONTRATADA e posteriormente o valor de{' '}
                  {Number(monthly[0]?.price).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })}{' '}
                  mensalmente, salvo se a contratante selecionar o pacote
                  semestral ou anual, neste caso a mesma irá pagar o valor
                  integral do plano selecionado;
                </li>
                <li className="ml-4">
                  3.2. O pagamento será efetuado através das opções disponíveis
                  na plataforma.
                </li>
              </ul>
              <ul className="mb-4">
                4. Direitos e obrigações das partes:
                <li className="ml-4">
                  4.1. A CONTRATADA se compromete a prestar os serviços de forma
                  eficiente e eficaz, com segurança, qualidade e
                  confidencialidade;
                </li>
                <li className="ml-4">
                  4.2. A CONTRATADA se compromete a manter o software atualizado
                  e em funcionamento regular, sem interrupções indevidas;
                </li>
                <li className="ml-4">
                  4.3. O CONTRATANTE se compromete a utilizar o software de
                  forma ética, honesta e legal;
                </li>
                <li className="ml-4">
                  4.4. O CONTRATANTE se compromete a pagar pontualmente os
                  valores devidos à CONTRATADA, estando ciente que o serviço
                  será interrompido imediatamente caso não seja identificado o
                  pagamento.
                </li>
              </ul>
              <ul className="mb-4">
                <p>5. Propriedade intelectual:</p>
                <li className="ml-4">
                  5.1. Todos os direitos de propriedade intelectual sobre o
                  software e sua estrutura são de propriedade exclusiva da
                  CONTRATADA;
                </li>
                <li className="ml-4">
                  5.2. É expressamente proibido ao CONTRATANTE copiar, modificar
                  ou distribuir o software, bem como utilizá-lo de forma diversa
                  da prevista neste contrato.
                </li>
              </ul>
              <ul className="mb-4">
                <p> 6. Rescisão:</p>
                <li className="ml-4">
                  6.1. O presente contrato poderá ser rescindido por qualquer
                  das partes, desde que haja notificação por escrito com
                  antecedência mínima de 30 dias;
                </li>

                <li className="ml-4">
                  6.2. Em caso de rescisão do contrato, o CONTRATANTE deverá
                  imediatamente interromper o uso do software e devolver à
                  CONTRATADA todas as informações e materiais que tenha em sua
                  posse.
                </li>
              </ul>
              <ul className="mb-4">
                <p>7. Foro:</p>
                <li className="ml-4">
                  7.1. Fica eleito o foro da Comarca de Teresópolis/RJ para
                  dirimir quaisquer controvérsias oriundas deste contrato, com
                  renúncia a qualquer outro, por mais privilegiado que seja.
                </li>
              </ul>
            </div>

            <div className="px-5 py-4 flex justify-end">
              <div className="flex items-center">
                <input
                  id="link-checkbox"
                  type="checkbox"
                  onChange={() => setChecked(!checked)}
                  checked={checked}
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
                <label
                  className={`ml-2 mr-4 font-medium ${
                    checked ? 'text-gray-900' : 'text-gray-300'
                  }`}
                >
                  Aceitar termos
                </label>
              </div>
              <button
                onClick={() => handleAccept()}
                disabled={!checked}
                className={`text-base border-2 border-blue-500 rounded py-2 px-3 text-gray-500 hover:border-blue-700 hover:text-gray-600 transition duration-150 ${
                  !checked ? 'cursor-not-allowed' : 'cursor-pointer'
                }`}
              >
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
